module.exports = __webpack_public_path__ + "static/img/haoyingxu.467fad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/haoyingxu.jpg
// module id = CWDS
// module chunks = 1